import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { PartnerWebScheduleState } from './store';

@NgModule({
  imports: [
    NgxsModule.forFeature([ PartnerWebScheduleState ])
  ]
})
export class PartnerWebSchedulesStoreModule {}
